module.exports = __webpack_public_path__ + "static/img/bilanca.cc9539e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/bilanca.png
// module id = HfaW
// module chunks = 0